import fetchAPI from '../../../utils/fetchApi';

export default async function createFavorite(itemId, xsrfToken) {
  try {
    return await fetchAPI({
      url: `/hp/api/favorite`,
      method: 'POST',
      payload: { itemId },
      xsrfToken,
    });
  } catch (err) {
    return { isFavorite: false };
  }
}
